import { LessonLink } from "@jelly/lesson";
import { findChapterForLinkByCourseLesson } from "../../../../services/Utils";

import course02 from "../../../course/course-02/course";
import lesson0207 from "../lesson-07/lesson";
import lesson0214 from "../lesson-14/lesson";

const lessonLinks: LessonLink[] = [
  {
    id: "3ef11bbd-5724-4eee-8550-61d0c6d331ce",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0207),
    lesson: lesson0207,
  },
  {
    id: "2807003f-0bd3-4916-b2d7-adbb06961fe4",
    course: {
      id: course02.id,
      slug: course02.slug as string,
      name: course02.name,
      publicId: course02.publicId,
    },
    chapter: findChapterForLinkByCourseLesson(course02, lesson0214),
    lesson: lesson0214,
  },
];

export default lessonLinks;
